import axios from 'axios'
import Alpine from 'alpinejs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.addEventListener('alpine:init', () => {
    Alpine.data('filteredContent', () => ({
        bestUseFilter: '',
        activeFilters: {
            'filter.v.availability': [],
            sort_by: ''
        },
        inStockOnly: false,
        loading: false,
        productCount: 0,

        init () {
            document.querySelectorAll('[data-filter]').forEach(filter => {
                this.activeFilters[filter.dataset.filter] = []
            })

            // this.activeFilters['filter.p.m.accentuate.best_use_filter'] = document.querySelector('[name="activity"]:checked').value

            this.productCount = document.getElementById('results').childElementCount - document.querySelectorAll('.collection-promo').length
            
        },

        handleFilterChange () {
            const searchParams = new URLSearchParams()

            Object.entries(this.activeFilters).forEach(([key, value]) => {
                if (value) {
                    // Array of values
                    if (Array.isArray(value)) {
                        value.forEach(filterValue => {
                            searchParams.append(key, filterValue)
                        })
                        return
                    }

                    // Single value
                    searchParams.append(key, value)
                }
            })

            axios.get(`?${searchParams.toString()}`)
                .then(response => {
                    const doc = new DOMParser().parseFromString(response.data, 'text/html')
                    const resultsHTML = doc.getElementById('results')
                    const currentResultsHTML = document.getElementById('results')

                    // Only replace the results html if the response if different
                    if (!currentResultsHTML.isEqualNode(resultsHTML)) {
                        document.getElementById('results').replaceWith(resultsHTML)
                        this.productCount = resultsHTML.childElementCount - document.querySelectorAll('.collection-promo').length

                        const resultsOffset = document.getElementById('results').offsetTop

                        if (window.scrollY > resultsOffset) {
                            window.scrollTo({
                                top: resultsOffset - 200,
                                left: 0,
                                behavior: 'auto'
                            })

                            setTimeout(() => ScrollTrigger.refresh(), 1000)
                        }
                    }
                })
        }
    }))
})
